import { useMemo, useState, useEffect } from 'react';
import { transformProduct } from '@/utils/products';
import { productsForOrder } from '@/store/cart';
import useBundleOffersSummary from '@/hooks/useBundleOffersSummary';
import useProductTags from '@/hooks/useProductTags';
import { usePersonalizedProductsIds } from '@/contexts/PersonalizedProductsIdsContext.jsx';

export default function useBrandProducts(brandProductsApiRes, a, setShowSnackbar) {
  const [productsOrder, setProductsOrder] = useState();
  const { productTags } = useProductTags();
  const { bundleOffersSummary } = useBundleOffersSummary();
  const { personalizedProductsIds } = usePersonalizedProductsIds();

  useEffect(() => {
    const productsForOrder$ = productsForOrder.subscribe(setProductsOrder);

    // eslint-disable-next-line
    return () => {
      productsForOrder$.unsubscribe();
    };
  }, []);

  const brandProducts = useMemo(() => {
    if (!brandProductsApiRes?.length) return null;

    return brandProductsApiRes.map(p => ({
      ...p,
      ...transformProduct(
        p,
        setShowSnackbar,
        undefined,
        productTags,
        bundleOffersSummary,
        undefined,
        undefined,
        undefined,
        personalizedProductsIds,
        a
      ),
    }));
  }, [brandProductsApiRes, productsOrder, personalizedProductsIds]);

  return { brandProducts };
}
